import { StyleSheet, Platform } from 'react-native';
import { getTheme } from '../src/theme/getTheme';
import type { Theme } from '../src/theme/getTheme';

export function getJoinDeepLinkStyles(t: Theme) {
  return StyleSheet.create({
    gradient: {
      flex: 1,
      paddingTop: Platform.OS === 'web' ? 40 : 60,
    },
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
    },
    loadingContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    loadingText: {
      color: t.gray[600],
      marginTop: 16,
      fontSize: 16,
    },
    errorTitle: {
      fontSize: 24,
      fontWeight: 'bold',
      color: t.error,
      marginBottom: 12,
      textAlign: 'center',
      paddingHorizontal: 24,
    },
    errorMessage: {
      color: t.gray[600],
      textAlign: 'center',
      marginBottom: 24,
      paddingHorizontal: 24,
    },
    card: {
      backgroundColor: t.background.card,
      borderRadius: 24,
      padding: 32,
      width: '100%',
      maxWidth: 400,
      alignItems: 'center',
      borderWidth: 1,
      borderColor: t.gray[200],
    },
    iconCircle: {
      width: 80,
      height: 80,
      borderRadius: 40,
      backgroundColor: `${t.primary}26`,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 24,
    },
    iconText: {
      fontSize: 36,
    },
    title: {
      fontSize: 24,
      fontWeight: 'bold',
      color: t.gray[900],
      marginBottom: 12,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 16,
      color: t.gray[600],
      marginBottom: 8,
      textAlign: 'center',
    },
    subtitleBold: {
      fontWeight: '600',
    },
    description: {
      fontSize: 14,
      color: t.gray[500],
      marginBottom: 32,
      textAlign: 'center',
      lineHeight: 20,
    },
    primaryButton: {
      backgroundColor: t.primary,
      paddingHorizontal: 48,
      paddingVertical: 16,
      borderRadius: 12,
      width: '100%',
      alignItems: 'center',
    },
    primaryButtonPressed: {
      opacity: 0.8,
    },
    primaryButtonHover: {
      opacity: 0.9,
    },
    primaryButtonText: {
      color: t.onPrimary,
      fontSize: 16,
      fontWeight: '600',
    },
    secondaryButton: {
      paddingHorizontal: 48,
      paddingVertical: 16,
      width: '100%',
      alignItems: 'center',
    },
    secondaryButtonPressed: {
      opacity: 0.8,
    },
    secondaryButtonHover: {
      opacity: 0.9,
    },
    secondaryButtonText: {
      color: t.primary,
      fontSize: 14,
      fontWeight: '600',
    },
    goHomeButton: {
      backgroundColor: t.primary,
      paddingHorizontal: 32,
      paddingVertical: 14,
      borderRadius: 12,
    },
    goHomeButtonPressed: {
      opacity: 0.8,
    },
    goHomeButtonHover: {
      opacity: 0.9,
    },
    goHomeButtonText: {
      color: t.onPrimary,
      fontSize: 16,
      fontWeight: '600',
    },
    buttonSpacing: {
      marginBottom: 12,
    },
    buttonSpacedTop: {
      marginTop: 12,
    },
  });
}

/** Default join-flow styles (dark app theme). */
export const joinDeepLinkStyles = getJoinDeepLinkStyles(getTheme());
